
import { defineComponent, PropType } from "vue";
import { RouteRecordRaw } from "vue-router";
export default defineComponent({
  props: {
    item: {
      type: Object as PropType<RouteRecordRaw>,
      required: true,
    },
  },
  setup(props) {
    const getChildPath = (childPath: string) => {
      const parentPath = props.item.path;
      if (parentPath === "/") {
        return parentPath + childPath;
      } else {
        return parentPath + "/" + childPath;
      }
    };
    return {
      getChildPath,
    };
  },
});
